module.exports = __webpack_public_path__ + "img/transaction-inactive.be011ee1.svg";